/**
 * Labstep
 *
 * @module Filter/Item
 * @desc A filter item showing an icon/picture and some text
 */

import classnames from 'classnames';
import FilterActionToggleCollapse from 'labstep-web/components/Filter/Action/ToggleCollapse';
import FilterSectionContent from 'labstep-web/components/Filter/List/Content';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { FilterItemProps } from './types';

export const FilterItem: React.FC<FilterItemProps> = ({
  component,
  icon,
  cornerIcon,
  cornerIconPosition,
  text,
  active,
  onClick,
  actionShortcuts,
  actionMenu,
  subFilters,
  useURL,
}) => (
  <>
    <div
      data-testid="filter-item"
      className={classnames(styles.container, {
        [styles.active]: active,
      })}
      data-cy={`components/Filter/Item:${text}`}
    >
      <div className={styles.innerContainer}>
        <div
          onClick={onClick}
          data-cy={`components/Filter/Item:name-container-${text}`}
        >
          <div>
            {component ||
              (icon && (
                <Icon
                  name={icon}
                  cornerIcon={cornerIcon}
                  cornerIconPosition={cornerIconPosition}
                />
              ))}
          </div>
          <div className={styles.text}>
            <span>{text}</span>
          </div>
        </div>
        <div>{actionShortcuts}</div>
        {subFilters && subFilters.filters.length > 0 && (
          <FilterActionToggleCollapse filter={subFilters.filter} />
        )}
      </div>
      {actionMenu}
    </div>
    {subFilters && subFilters.filters.length > 0 && (
      <div className={styles.subFilter} data-testid="sub-filter">
        <FilterSectionContent
          filters={subFilters.filters}
          filter={subFilters.filter}
          useURL={useURL}
        />
      </div>
    )}
  </>
);
